import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { AddUpdateTestimonialsComponent } from './add-update-testimonials/add-update-testimonials.component';
import { TestimonialDetailsComponent } from './testimonial-details/testimonial-details.component';

const routes: Routes = [
  {
    path: '',
    component: TestimonialsComponent
  },
  {
    path: 'add',
    component: AddUpdateTestimonialsComponent
  },
  {
    path: 'update/:id',
    component: AddUpdateTestimonialsComponent
  },
  {
    path: 'detail/:id',
    component: TestimonialDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestimonialRoutingModule { }
